// Cookie Consent

window.addEventListener("load", function(){
	window.cookieconsent.initialise({
		"palette": {
			"popup": {
				"background": "#27cc87",
				"text": "#ffffff"
			},
			"button": {
				"background": "#12a366",
				"text": "#ffffff"
			}
		},
		"content": {
			"message": "Wij gebruiken cookies om uw gebruikerservaring te verbeteren en statistieken bij te houden. Meer informatie vindt u in ons",
			"dismiss": "Sluit",
			"link": "privacy statement",
			"href": "/privacy-statement"
		}
	})
});